import React from 'react';
export function PortfolioPreview() {
  const projects = [{
    id: 1,
    title: 'Modern Farmhouse Kitchen',
    location: 'Clovis, CA',
    image: 'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?auto=format&fit=crop&q=80'
  }, {
    id: 2,
    title: 'Master Bath Retreat',
    location: 'Fresno, CA',
    image: 'https://images.unsplash.com/photo-1584622650111-993a426fbf0a?auto=format&fit=crop&q=80'
  }, {
    id: 3,
    title: 'Open Concept Living',
    location: 'Madera County',
    image: 'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?auto=format&fit=crop&q=80'
  }, {
    id: 4,
    title: 'Custom Vanity & Shower',
    location: 'Fresno, CA',
    image: 'https://images.unsplash.com/photo-1604709177227-3977c3302901?auto=format&fit=crop&q=80'
  }, {
    id: 5,
    title: "Chef's Kitchen Remodel",
    location: 'Clovis, CA',
    image: 'https://images.unsplash.com/photo-1556911220-e15b29be8c8f?auto=format&fit=crop&q=80'
  }, {
    id: 6,
    title: 'Whole Home Update',
    location: 'Tulare County',
    image: 'https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?auto=format&fit=crop&q=80'
  }];
  return <section id="gallery" className="py-20 bg-brand-offwhite" data-id="element-129">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-130">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12" data-id="element-131">
          <div data-id="element-132">
            <h2 className="text-3xl md:text-4xl font-bold text-brand-blue mb-4" data-id="element-133">
              Recent Projects
            </h2>
            <p className="text-lg text-brand-gray max-w-2xl font-body" data-id="element-134">
              A selection of our latest remodeling work across the Central
              Valley.
            </p>
          </div>
          <a href="#gallery-full" className="hidden md:inline-flex bg-brand-blue text-white px-8 py-4 font-bold hover:bg-blue-800 transition-colors mt-6 md:mt-0" data-id="element-135">
            View All Projects
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-id="element-136">
          {projects.map(project => <div key={project.id} className="group relative aspect-square overflow-hidden rounded bg-gray-200" data-id="element-137">
              <img src={project.image} alt={project.title} className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700" data-id="element-138" />
              <div className="absolute inset-0 bg-gradient-to-t from-brand-blue/90 via-brand-blue/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-6" data-id="element-139">
                <span className="text-brand-gold text-sm font-bold tracking-wider mb-1" data-id="element-140">
                  No. {project.id.toString().padStart(3, '0')}
                </span>
                <h3 className="text-white text-xl font-medium mb-1" data-id="element-141">
                  {project.title}
                </h3>
                <p className="text-gray-300 text-sm" data-id="element-142">{project.location}</p>
              </div>
            </div>)}
        </div>

        <div className="mt-10 text-center md:hidden" data-id="element-143">
          <a href="#gallery-full" className="inline-flex bg-brand-blue text-white px-8 py-4 font-bold hover:bg-blue-800 transition-colors w-full justify-center" data-id="element-144">
            View All Projects
          </a>
        </div>
      </div>
    </section>;
}